// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options, formDataBodySerializer } from '@hey-api/client-fetch';
import type { ModelsUploadStreamData, ModelsUploadStreamError, ModelsUploadStreamResponse, StatusGetDeploymentData, StatusGetDeploymentError, StatusGetDeploymentResponse, UsersQueryData, UsersQueryError, UsersQueryResponse, UsersInviteData, UsersInviteError, UsersInviteResponse, UsersDeactivateData, UsersDeactivateError, UsersDeactivateResponse, UsersActivateData, UsersActivateError, UsersActivateResponse, UsersEditData, UsersEditError, UsersEditResponse, PipelinesCreateData, PipelinesCreateError, PipelinesCreateResponse, PipelinesGetVersionData, PipelinesGetVersionError, PipelinesGetVersionResponse, PipelinesGetLogsData, PipelinesGetLogsError, PipelinesGetLogsResponse, PlateauGetPipelineTopicNameData, PlateauGetPipelineTopicNameError, PlateauGetPipelineTopicNameResponse, PlateauGetTopicNameData, PlateauGetTopicNameError, PlateauGetTopicNameResponse, AssaysListData, AssaysListError, AssaysListResponse, AssaysGetAssayByIdData, AssaysGetAssayByIdError, AssaysGetAssayByIdResponse, AssaysFilterData, AssaysFilterError, AssaysFilterResponse, AssaysGetAssayResultsData, AssaysGetAssayResultsError, AssaysGetAssayResultsResponse, AssaysRunInteractiveBaselineData, AssaysRunInteractiveBaselineError, AssaysRunInteractiveBaselineResponse, AssaysGetBaselineData, AssaysGetBaselineError, AssaysGetBaselineResponse, AssaysCreateData, AssaysCreateError, AssaysCreateResponse, AssaysSetActiveData, AssaysSetActiveError, AssaysSetActiveResponse, AssaysRunInteractiveData, AssaysRunInteractiveError, AssaysRunInteractiveResponse, AssaysSummarizeData, AssaysSummarizeError, AssaysSummarizeResponse, WorkspacesCreateData, WorkspacesCreateError, WorkspacesCreateResponse, WorkspacesAddUserData, WorkspacesAddUserError, WorkspacesAddUserResponse, WorkspacesListData, WorkspacesListError, WorkspacesListResponse, WorkspacesListUsersData, WorkspacesListUsersError, WorkspacesListUsersResponse, WorkspacesRemoveUserData, WorkspacesRemoveUserError, WorkspacesRemoveUserResponse, WorkspacesValidateError, WorkspacesValidateResponse, V1ModelGetModelByIdData, V1ModelGetModelByIdError, V1ModelGetModelByIdResponse, V1ModelGetConfigData, V1ModelGetConfigError, V1ModelGetConfigResponse, ModelsListVersionsData, ModelsListVersionsError, ModelsListVersionsResponse, ModelsGetData, ModelsGetError, ModelsGetResponse, FeaturesListError, FeaturesListResponse, ConnectionsListData, ConnectionsListError, ConnectionsListResponse, ConnectionsCreateData, ConnectionsCreateError, ConnectionsCreateResponse, ConnectionsGetByIdData, ConnectionsGetByIdError, ConnectionsGetByIdResponse, ConnectionsGetData, ConnectionsGetError, ConnectionsGetResponse, ConnectionsDeleteData, ConnectionsDeleteError, ConnectionsDeleteResponse, ConnectionsAddToWorkspaceData, ConnectionsAddToWorkspaceError, ConnectionsAddToWorkspaceResponse, ConnectionsRemoveFromWorkspaceData, ConnectionsRemoveFromWorkspaceError, ConnectionsRemoveFromWorkspaceResponse, AdminGetPipelineExternalUrlData, AdminGetPipelineExternalUrlError, AdminGetPipelineExternalUrlResponse, AdminGetPipelineInternalUrlData, AdminGetPipelineInternalUrlError, AdminGetPipelineInternalUrlResponse, AttachRegistryToWorkspaceData, AttachRegistryToWorkspaceError, AttachRegistryToWorkspaceResponse2, CreateRegistryData, CreateRegistryError, CreateRegistryResponse2, DeleteModelData, DeleteModelError, DeleteModelResponse2, DeleteModelVersionsData, DeleteModelVersionsError, DeleteModelVersionsResponse2, GetModelVersionByIdData, GetModelVersionByIdError, GetModelVersionByIdResponse, GetRegistryData, GetRegistryError, GetRegistryResponse2, GetUploadLogsData, GetUploadLogsError, GetUploadLogsResponse, InsertModelConfigData, InsertModelConfigError, InsertModelConfigResponse2, ListModelsData, ListModelsError, ListModelsResponse2, ListRegistriesData, ListRegistriesError, ListRegistriesResponse2, ListRegistryModelVersionArtifactsData, ListRegistryModelVersionArtifactsError, ListRegistryModelVersionArtifactsResponse2, ListRegistryModelVersionsData, ListRegistryModelVersionsError, ListRegistryModelVersionsResponse, ListRegistryModelsData, ListRegistryModelsError, ListRegistryModelsResponse, ListVersionsForModelData, ListVersionsForModelError, ListVersionsForModelResponse, RemoveRegistryFromWorkspaceData, RemoveRegistryFromWorkspaceError, RemoveRegistryFromWorkspaceResponse2, ModelsUploadData, ModelsUploadError, ModelsUploadResponse, ModelsUploadAndConvertData, ModelsUploadAndConvertError, ModelsUploadAndConvertResponse, UploadFromRegistryData, UploadFromRegistryError, UploadFromRegistryResponse2, AddEdgeToPublishData, AddEdgeToPublishError, AddEdgeToPublishResponse, DeletePipelineData, DeletePipelineError, DeletePipelineResponse2, DeletePipelineVersionsData, DeletePipelineVersionsError, DeletePipelineVersionsResponse2, GetPublishStatusData, GetPublishStatusError, GetPublishStatusResponse, ListEdgesByPublishIdData, ListEdgesByPublishIdError, ListEdgesByPublishIdResponse, ListPipelineVersionsData, ListPipelineVersionsError, ListPipelineVersionsResponse, ListPipelinesData, ListPipelinesError, ListPipelinesResponse2, ListPublishesForPipelineData, ListPublishesForPipelineError, ListPublishesForPipelineResponse, PublishPipelineData, PublishPipelineError, PublishPipelineResponse, RemoveEdgeData, RemoveEdgeError, RemoveEdgeResponse2, DeleteOrchestrationsData, DeleteOrchestrationsError, DeleteOrchestrationsResponse2, OrchestrationDownloadData, OrchestrationDownloadError, OrchestrationDownloadResponse, OrchestrationGetByIdData, OrchestrationGetByIdError, OrchestrationGetByIdResponse, OrchestrationListData, OrchestrationListError, OrchestrationListResponse, OrchestrationListAllData, OrchestrationListAllError, OrchestrationListAllResponse, OrchestrationUploadData, OrchestrationUploadError, OrchestrationUploadResponse, TaskGetByIdData, TaskGetByIdError, TaskGetByIdResponse, GetLogsForRunData, GetLogsForRunError, GetLogsForRunResponse2, GetRunDetailsData, GetRunDetailsError, GetRunDetailsResponse, GetTasksByOrchShaData, GetTasksByOrchShaError, GetTasksByOrchShaResponse2, KillData, KillError, KillResponse, TaskListData, TaskListError, TaskListResponse, ListTaskRunsData, ListTaskRunsError, ListTaskRunsResponse2, PauseData, PauseError, PauseResponse, NetworkServiceData, NetworkServiceError, NetworkServiceResponse, OneshotData, OneshotError, OneshotResponse, CronJobData, CronJobError, CronJobResponse, PipelinesDeployData, PipelinesDeployError, PipelinesDeployResponse, PipelinesUndeployData, PipelinesUndeployError, PipelinesUndeployResponse, GetData, GetError, GetResponse, GetByIdData, GetByIdError, GetByIdResponse, GetNextRunData, GetNextRunError, GetNextRunResponse2, GetResultsData, GetResultsError, GetResultsResponse, PreviewData, PreviewError, PreviewResponse2, PreviewBaselineBinningData, PreviewBaselineBinningError, PreviewBaselineBinningResponse, ScheduleData, ScheduleError, ScheduleResponse2, ScoreData2, ScoreError, ScoreResponse2, SetActiveData, SetActiveError, SetActiveResponse2 } from './types.gen';

/**
 * Stream a large model directly into storage
 * Streams a potentially large model directly into storage.
 */
export const modelsUploadStream = (options: Options<ModelsUploadStreamData>) => { return (options?.client ?? client).post<ModelsUploadStreamResponse, ModelsUploadStreamError>({
    ...options,
    url: '/v1/api/models/upload_stream'
}); };

/**
 * Deployment statuses are made up of the engine pods and the statuses of the pipelines and models in each of the running engines
 * Gets the full status of a deployment.
 */
export const statusGetDeployment = (options: Options<StatusGetDeploymentData>) => { return (options?.client ?? client).post<StatusGetDeploymentResponse, StatusGetDeploymentError>({
    ...options,
    url: '/v1/api/status/get_deployment'
}); };

/**
 * Query existing users
 * Returns users that satisfy the given query.
 */
export const usersQuery = (options: Options<UsersQueryData>) => { return (options?.client ?? client).post<UsersQueryResponse, UsersQueryError>({
    ...options,
    url: '/v1/api/users/query'
}); };

/**
 * Invite user to Wallaroo
 * Invite a new user to your Wallaroo cluster by sending them an invitation email.
 */
export const usersInvite = (options: Options<UsersInviteData>) => { return (options?.client ?? client).post<UsersInviteResponse, UsersInviteError>({
    ...options,
    url: '/v1/api/users/invite'
}); };

/**
 * Deactivate user
 * Deactivate an existing Wallaroo user.
 */
export const usersDeactivate = (options: Options<UsersDeactivateData>) => { return (options?.client ?? client).post<UsersDeactivateResponse, UsersDeactivateError>({
    ...options,
    url: '/v1/api/users/deactivate'
}); };

/**
 * Activate user
 * Activate a previously deactivated user.
 */
export const usersActivate = (options: Options<UsersActivateData>) => { return (options?.client ?? client).post<UsersActivateResponse, UsersActivateError>({
    ...options,
    url: '/v1/api/users/activate'
}); };

/**
 * Edit users in Wallaroo
 */
export const usersEdit = (options: Options<UsersEditData>) => { return (options?.client ?? client).post<UsersEditResponse, UsersEditError>({
    ...options,
    url: '/v1/api/user'
}); };

/**
 * Create a new pipeline
 * Creates a new pipeline.
 */
export const pipelinesCreate = (options: Options<PipelinesCreateData>) => { return (options?.client ?? client).post<PipelinesCreateResponse, PipelinesCreateError>({
    ...options,
    url: '/v1/api/pipelines/create'
}); };

/**
 * Get pipeline version
 * Undeploys a previously deployed pipeline.
 */
export const pipelinesGetVersion = (options: Options<PipelinesGetVersionData>) => { return (options?.client ?? client).post<PipelinesGetVersionResponse, PipelinesGetVersionError>({
    ...options,
    url: '/v1/api/pipelines/get_version'
}); };

/**
 * Fetch pipeline logs
 * Fetch pipeline logs.
 */
export const pipelinesGetLogs = (options: Options<PipelinesGetLogsData>) => { return (options?.client ?? client).post<PipelinesGetLogsResponse, PipelinesGetLogsError>({
    ...options,
    url: '/v1/api/pipelines/get_logs'
}); };

/**
 * Get pipeline topic name
 * Returns the given pipeline's topic name.
 */
export const plateauGetPipelineTopicName = (options: Options<PlateauGetPipelineTopicNameData>) => { return (options?.client ?? client).post<PlateauGetPipelineTopicNameResponse, PlateauGetPipelineTopicNameError>({
    ...options,
    url: '/v1/api/plateau/get_pipeline_topic_name'
}); };

/**
 * Get topic name
 * Returns the topic name for the given pipeline.
 */
export const plateauGetTopicName = (options: Options<PlateauGetTopicNameData>) => { return (options?.client ?? client).post<PlateauGetTopicNameResponse, PlateauGetTopicNameError>({
    ...options,
    url: '/v1/api/plateau/get_topic_name'
}); };

/**
 * List assays
 * Returns the list of existing assays.
 */
export const assaysList = (options: Options<AssaysListData>) => { return (options?.client ?? client).post<AssaysListResponse, AssaysListError>({
    ...options,
    url: '/v1/api/assays/list'
}); };

/**
 * Retrieve an Assay by it's primary id.
 * Retrieve an assay by it's primary id.
 */
export const assaysGetAssayById = (options: Options<AssaysGetAssayByIdData>) => { return (options?.client ?? client).post<AssaysGetAssayByIdResponse, AssaysGetAssayByIdError>({
    ...options,
    url: '/v1/api/assays/get_assay_by_id'
}); };

/**
 * Retrieve assay configs, filtered and sorted as requested.
 * Returns the list of existing assays filterable by assay name, id, active, creation date, and last run date.
 */
export const assaysFilter = (options: Options<AssaysFilterData>) => { return (options?.client ?? client).post<AssaysFilterResponse, AssaysFilterError>({
    ...options,
    url: '/v1/api/assays/filter'
}); };

/**
 * Temporary mockup to get get assay results by assay_id.
 * Returns assay results.
 */
export const assaysGetAssayResults = (options: Options<AssaysGetAssayResultsData>) => { return (options?.client ?? client).post<AssaysGetAssayResultsResponse, AssaysGetAssayResultsError>({
    ...options,
    url: '/v1/api/assays/get_assay_results'
}); };

/**
 * Create interactive baseline
 * Creates an interactive assay baseline.
 */
export const assaysRunInteractiveBaseline = (options: Options<AssaysRunInteractiveBaselineData>) => { return (options?.client ?? client).post<AssaysRunInteractiveBaselineResponse, AssaysRunInteractiveBaselineError>({
    ...options,
    url: '/v1/api/assays/run_interactive_baseline'
}); };

/**
 * Get assay baseline
 * Retrieves an assay baseline.
 */
export const assaysGetBaseline = (options: Options<AssaysGetBaselineData>) => { return (options?.client ?? client).post<AssaysGetBaselineResponse, AssaysGetBaselineError>({
    ...options,
    url: '/v1/api/assays/get_baseline'
}); };

/**
 * Create assay
 * Creates an assay.
 */
export const assaysCreate = (options: Options<AssaysCreateData>) => { return (options?.client ?? client).post<AssaysCreateResponse, AssaysCreateError>({
    ...options,
    url: '/v1/api/assays/create'
}); };

/**
 * Activate or deactivate assay
 * Activates or deactivates an assay.
 */
export const assaysSetActive = (options: Options<AssaysSetActiveData>) => { return (options?.client ?? client).post<AssaysSetActiveResponse, AssaysSetActiveError>({
    ...options,
    url: '/v1/api/assays/set_active'
}); };

/**
 * Run assay interactively
 * Runs an assay interactively.
 */
export const assaysRunInteractive = (options: Options<AssaysRunInteractiveData>) => { return (options?.client ?? client).post<AssaysRunInteractiveResponse, AssaysRunInteractiveError>({
    ...options,
    url: '/v1/api/assays/run_interactive'
}); };

/**
 * Generate static baseline summary stats for a vector or windowed data
 * Creates an interactive assay baseline.
 */
export const assaysSummarize = (options: Options<AssaysSummarizeData>) => { return (options?.client ?? client).post<AssaysSummarizeResponse, AssaysSummarizeError>({
    ...options,
    url: '/v1/api/assays/summarize'
}); };

/**
 * Create a workspace
 * Create a new Workspace
 */
export const workspacesCreate = (options: Options<WorkspacesCreateData>) => { return (options?.client ?? client).post<WorkspacesCreateResponse, WorkspacesCreateError>({
    ...options,
    url: '/v1/api/workspaces/create'
}); };

/**
 * Add user to workspace
 * Adds an existing user to the given workspace.
 */
export const workspacesAddUser = (options: Options<WorkspacesAddUserData>) => { return (options?.client ?? client).post<WorkspacesAddUserResponse, WorkspacesAddUserError>({
    ...options,
    url: '/v1/api/workspaces/add_user'
}); };

/**
 * List available workspaces
 * List Workspaces available to the current User
 */
export const workspacesList = (options: Options<WorkspacesListData>) => { return (options?.client ?? client).post<WorkspacesListResponse, WorkspacesListError>({
    ...options,
    url: '/v1/api/workspaces/list'
}); };

/**
 * List workspace users
 * List the Users of a given Workspace
 */
export const workspacesListUsers = (options: Options<WorkspacesListUsersData>) => { return (options?.client ?? client).post<WorkspacesListUsersResponse, WorkspacesListUsersError>({
    ...options,
    url: '/v1/api/workspaces/list_users'
}); };

/**
 * Removes a user from a workspace
 * Remove a User from a given Workspace
 */
export const workspacesRemoveUser = (options: Options<WorkspacesRemoveUserData>) => { return (options?.client ?? client).post<WorkspacesRemoveUserResponse, WorkspacesRemoveUserError>({
    ...options,
    url: '/v1/api/workspaces/remove_user'
}); };

/**
 * Runs one-time migrations for workspaces that fail validation check.
 */
export const workspacesValidate = (options?: Options) => { return (options?.client ?? client).post<WorkspacesValidateResponse, WorkspacesValidateError>({
    ...options,
    url: '/v1/api/workspaces/validate'
}); };

/**
 * Retrieve a Model by it's primary id.
 * Retrieve a model by it's primary id.
 */
export const v1ModelGetModelById = (options: Options<V1ModelGetModelByIdData>) => { return (options?.client ?? client).post<V1ModelGetModelByIdResponse, V1ModelGetModelByIdError>({
    ...options,
    url: '/v1/api/models/get_by_id'
}); };

/**
 * Get latest model config, by a model id.
 * Retrieve the latest model configuration, by a model id.
 */
export const v1ModelGetConfig = (options: Options<V1ModelGetConfigData>) => { return (options?.client ?? client).post<V1ModelGetConfigResponse, V1ModelGetConfigError>({
    ...options,
    url: '/v1/api/models/get_config_by_id'
}); };

/**
 * Retrieve versions of a model
 * Returns all versions for a given model.
 */
export const modelsListVersions = (options: Options<ModelsListVersionsData>) => { return (options?.client ?? client).post<ModelsListVersionsResponse, ModelsListVersionsError>({
    ...options,
    url: '/v1/api/models/list_versions'
}); };

/**
 * Retrieve model details
 * Returns details about a single Model, including attached versions.
 */
export const modelsGet = (options: Options<ModelsGetData>) => { return (options?.client ?? client).post<ModelsGetResponse, ModelsGetError>({
    ...options,
    url: '/v1/api/models/get'
}); };

/**
 * List enabled features
 * List enabled features.
 */
export const featuresList = (options?: Options) => { return (options?.client ?? client).post<FeaturesListResponse, FeaturesListError>({
    ...options,
    url: '/v1/api/features/list'
}); };

/**
 * List all connections
 * List Connections
 */
export const connectionsList = (options: Options<ConnectionsListData>) => { return (options?.client ?? client).post<ConnectionsListResponse, ConnectionsListError>({
    ...options,
    url: '/v1/api/connections/list'
}); };

/**
 * Create a connection
 * Create a new connection
 */
export const connectionsCreate = (options: Options<ConnectionsCreateData>) => { return (options?.client ?? client).post<ConnectionsCreateResponse, ConnectionsCreateError>({
    ...options,
    url: '/v1/api/connections/create'
}); };

/**
 * Get a connection by Id
 * Get a connection by its Id
 */
export const connectionsGetById = (options: Options<ConnectionsGetByIdData>) => { return (options?.client ?? client).post<ConnectionsGetByIdResponse, ConnectionsGetByIdError>({
    ...options,
    url: '/v1/api/connections/get_by_id'
}); };

/**
 * Get a connection
 * Get a connection
 */
export const connectionsGet = (options: Options<ConnectionsGetData>) => { return (options?.client ?? client).post<ConnectionsGetResponse, ConnectionsGetError>({
    ...options,
    url: '/v1/api/connections/get'
}); };

/**
 * Delete a connection
 * Delete a connection
 */
export const connectionsDelete = (options: Options<ConnectionsDeleteData>) => { return (options?.client ?? client).post<ConnectionsDeleteResponse, ConnectionsDeleteError>({
    ...options,
    url: '/v1/api/connections/delete'
}); };

/**
 * Add a connection to a workspace
 * Create a new workspace connection
 */
export const connectionsAddToWorkspace = (options: Options<ConnectionsAddToWorkspaceData>) => { return (options?.client ?? client).post<ConnectionsAddToWorkspaceResponse, ConnectionsAddToWorkspaceError>({
    ...options,
    url: '/v1/api/connections/add_to_workspace'
}); };

/**
 * Remove a connection from a workspace
 * Remove a connection from a workspace
 */
export const connectionsRemoveFromWorkspace = (options: Options<ConnectionsRemoveFromWorkspaceData>) => { return (options?.client ?? client).post<ConnectionsRemoveFromWorkspaceResponse, ConnectionsRemoveFromWorkspaceError>({
    ...options,
    url: '/v1/api/connections/remove_from_workspace'
}); };

/**
 * Returns the URL for the given pipeline that clients may send inferences to from outside of the cluster.
 * Returns the external inference URL for a given pipeline.
 */
export const adminGetPipelineExternalUrl = (options: Options<AdminGetPipelineExternalUrlData>) => { return (options?.client ?? client).post<AdminGetPipelineExternalUrlResponse, AdminGetPipelineExternalUrlError>({
    ...options,
    url: '/v1/api/admin/get_pipeline_external_url'
}); };

/**
 * Returns the URL for the given pipeline that clients may send inferences to from inside of the cluster.
 * Returns the internal inference URL for a given pipeline.
 */
export const adminGetPipelineInternalUrl = (options: Options<AdminGetPipelineInternalUrlData>) => { return (options?.client ?? client).post<AdminGetPipelineInternalUrlResponse, AdminGetPipelineInternalUrlError>({
    ...options,
    url: '/v1/api/admin/get_pipeline_internal_url'
}); };

export const attachRegistryToWorkspace = (options: Options<AttachRegistryToWorkspaceData>) => { return (options?.client ?? client).post<AttachRegistryToWorkspaceResponse2, AttachRegistryToWorkspaceError>({
    ...options,
    url: '/v1/api/models/attach_registry_to_workspace'
}); };

export const createRegistry = (options: Options<CreateRegistryData>) => { return (options?.client ?? client).post<CreateRegistryResponse2, CreateRegistryError>({
    ...options,
    url: '/v1/api/models/create_registry'
}); };

/**
 * Deletes the specified model.
 */
export const deleteModel = (options: Options<DeleteModelData>) => { return (options?.client ?? client).post<DeleteModelResponse2, DeleteModelError>({
    ...options,
    url: '/v1/api/models/delete_model'
}); };

/**
 * Deletes the specified model versions.
 */
export const deleteModelVersions = (options: Options<DeleteModelVersionsData>) => { return (options?.client ?? client).post<DeleteModelVersionsResponse2, DeleteModelVersionsError>({
    ...options,
    url: '/v1/api/models/delete_model_versions'
}); };

export const getModelVersionById = (options: Options<GetModelVersionByIdData>) => { return (options?.client ?? client).post<GetModelVersionByIdResponse, GetModelVersionByIdError>({
    ...options,
    url: '/v1/api/models/get_model_version_by_id'
}); };

export const getRegistry = (options: Options<GetRegistryData>) => { return (options?.client ?? client).post<GetRegistryResponse2, GetRegistryError>({
    ...options,
    url: '/v1/api/models/get_registry'
}); };

export const getUploadLogs = (options: Options<GetUploadLogsData>) => { return (options?.client ?? client).post<GetUploadLogsResponse, GetUploadLogsError>({
    ...options,
    url: '/v1/api/models/get_upload_logs'
}); };

export const insertModelConfig = (options: Options<InsertModelConfigData>) => { return (options?.client ?? client).post<InsertModelConfigResponse2, InsertModelConfigError>({
    ...options,
    url: '/v1/api/models/insert_model_config'
}); };

export const listModels = (options: Options<ListModelsData>) => { return (options?.client ?? client).post<ListModelsResponse2, ListModelsError>({
    ...options,
    url: '/v1/api/models/list'
}); };

export const listRegistries = (options: Options<ListRegistriesData>) => { return (options?.client ?? client).post<ListRegistriesResponse2, ListRegistriesError>({
    ...options,
    url: '/v1/api/models/list_registries'
}); };

export const listRegistryModelVersionArtifacts = (options: Options<ListRegistryModelVersionArtifactsData>) => { return (options?.client ?? client).post<ListRegistryModelVersionArtifactsResponse2, ListRegistryModelVersionArtifactsError>({
    ...options,
    url: '/v1/api/models/list_registry_model_version_artifacts'
}); };

export const listRegistryModelVersions = (options: Options<ListRegistryModelVersionsData>) => { return (options?.client ?? client).post<ListRegistryModelVersionsResponse, ListRegistryModelVersionsError>({
    ...options,
    url: '/v1/api/models/list_registry_model_versions'
}); };

export const listRegistryModels = (options: Options<ListRegistryModelsData>) => { return (options?.client ?? client).post<ListRegistryModelsResponse, ListRegistryModelsError>({
    ...options,
    url: '/v1/api/models/list_registry_models'
}); };

export const listVersionsForModel = (options: Options<ListVersionsForModelData>) => { return (options?.client ?? client).post<ListVersionsForModelResponse, ListVersionsForModelError>({
    ...options,
    url: '/v1/api/models/list_versions_for_model'
}); };

export const removeRegistryFromWorkspace = (options: Options<RemoveRegistryFromWorkspaceData>) => { return (options?.client ?? client).post<RemoveRegistryFromWorkspaceResponse2, RemoveRegistryFromWorkspaceError>({
    ...options,
    url: '/v1/api/models/remove_registry_from_workspace'
}); };

export const modelsUpload = (options: Options<ModelsUploadData>) => { return (options?.client ?? client).post<ModelsUploadResponse, ModelsUploadError>({
    ...options,
    ...formDataBodySerializer,
    url: '/v1/api/models/upload'
}); };

export const modelsUploadAndConvert = (options: Options<ModelsUploadAndConvertData>) => { return (options?.client ?? client).post<ModelsUploadAndConvertResponse, ModelsUploadAndConvertError>({
    ...options,
    ...formDataBodySerializer,
    url: '/v1/api/models/upload_and_convert'
}); };

export const uploadFromRegistry = (options: Options<UploadFromRegistryData>) => { return (options?.client ?? client).post<UploadFromRegistryResponse2, UploadFromRegistryError>({
    ...options,
    url: '/v1/api/models/upload_from_registry'
}); };

/**
 * Publishes a given pipeline for deployment on the edge.
 */
export const addEdgeToPublish = (options: Options<AddEdgeToPublishData>) => { return (options?.client ?? client).post<AddEdgeToPublishResponse, AddEdgeToPublishError>({
    ...options,
    url: '/v1/api/pipelines/add_edge_to_publish'
}); };

/**
 * Deletes the specified pipeline versions.
 */
export const deletePipeline = (options: Options<DeletePipelineData>) => { return (options?.client ?? client).post<DeletePipelineResponse2, DeletePipelineError>({
    ...options,
    url: '/v1/api/pipelines/delete_pipeline'
}); };

/**
 * Deletes the specified pipeline versions.
 */
export const deletePipelineVersions = (options: Options<DeletePipelineVersionsData>) => { return (options?.client ?? client).post<DeletePipelineVersionsResponse2, DeletePipelineVersionsError>({
    ...options,
    url: '/v1/api/pipelines/delete_pipeline_versions'
}); };

/**
 * Fetches a pipeline's publish status.
 */
export const getPublishStatus = (options: Options<GetPublishStatusData>) => { return (options?.client ?? client).post<GetPublishStatusResponse, GetPublishStatusError>({
    ...options,
    url: '/v1/api/pipelines/get_publish_status'
}); };

/**
 * Lists the edges related to a publish id.
 */
export const listEdgesByPublishId = (options: Options<ListEdgesByPublishIdData>) => { return (options?.client ?? client).post<ListEdgesByPublishIdResponse, ListEdgesByPublishIdError>({
    ...options,
    url: '/v1/api/pipelines/list_edges_by_publish_id'
}); };

/**
 * Lists the publishes for a Pipeline. This aggregates publishes for all versions of that Pipeline.
 */
export const listPipelineVersions = (options: Options<ListPipelineVersionsData>) => { return (options?.client ?? client).post<ListPipelineVersionsResponse, ListPipelineVersionsError>({
    ...options,
    url: '/v1/api/pipelines/list_pipeline_versions'
}); };

/**
 * Lists the publishes for a Pipeline. This aggregates publishes for all versions of that Pipeline.
 */
export const listPipelines = (options: Options<ListPipelinesData>) => { return (options?.client ?? client).post<ListPipelinesResponse2, ListPipelinesError>({
    ...options,
    url: '/v1/api/pipelines/list_pipelines'
}); };

/**
 * Lists the publishes for a Pipeline. This aggregates publishes for all versions of that Pipeline.
 */
export const listPublishesForPipeline = (options: Options<ListPublishesForPipelineData>) => { return (options?.client ?? client).post<ListPublishesForPipelineResponse, ListPublishesForPipelineError>({
    ...options,
    url: '/v1/api/pipelines/list_publishes_for_pipeline'
}); };

/**
 * Publishes a given pipeline for deployment on the edge.
 */
export const publishPipeline = (options: Options<PublishPipelineData>) => { return (options?.client ?? client).post<PublishPipelineResponse, PublishPipelineError>({
    ...options,
    url: '/v1/api/pipelines/publish'
}); };

/**
 * Publishes a given pipeline for deployment on the edge.
 */
export const removeEdge = (options: Options<RemoveEdgeData>) => { return (options?.client ?? client).post<RemoveEdgeResponse2, RemoveEdgeError>({
    ...options,
    url: '/v1/api/pipelines/remove_edge'
}); };

/**
 * Deletes the specified model versions.
 */
export const deleteOrchestrations = (options: Options<DeleteOrchestrationsData>) => { return (options?.client ?? client).post<DeleteOrchestrationsResponse2, DeleteOrchestrationsError>({
    ...options,
    url: '/v1/api/orchestration/delete_orchestrations'
}); };

export const orchestrationDownload = (options: Options<OrchestrationDownloadData>) => { return (options?.client ?? client).get<OrchestrationDownloadResponse, OrchestrationDownloadError>({
    ...options,
    url: '/v1/api/orchestration/download'
}); };

export const orchestrationGetById = (options: Options<OrchestrationGetByIdData>) => { return (options?.client ?? client).post<OrchestrationGetByIdResponse, OrchestrationGetByIdError>({
    ...options,
    url: '/v1/api/orchestration/get_by_id'
}); };

export const orchestrationList = (options: Options<OrchestrationListData>) => { return (options?.client ?? client).post<OrchestrationListResponse, OrchestrationListError>({
    ...options,
    url: '/v1/api/orchestration/list'
}); };

export const orchestrationListAll = (options: Options<OrchestrationListAllData>) => { return (options?.client ?? client).post<OrchestrationListAllResponse, OrchestrationListAllError>({
    ...options,
    url: '/v1/api/orchestration/list_all'
}); };

export const orchestrationUpload = (options: Options<OrchestrationUploadData>) => { return (options?.client ?? client).post<OrchestrationUploadResponse, OrchestrationUploadError>({
    ...options,
    ...formDataBodySerializer,
    url: '/v1/api/orchestration/upload'
}); };

export const taskGetById = (options: Options<TaskGetByIdData>) => { return (options?.client ?? client).post<TaskGetByIdResponse, TaskGetByIdError>({
    ...options,
    url: '/v1/api/task/get_by_id'
}); };

export const getLogsForRun = (options: Options<GetLogsForRunData>) => { return (options?.client ?? client).post<GetLogsForRunResponse2, GetLogsForRunError>({
    ...options,
    url: '/v1/api/task/get_logs_for_run'
}); };

export const getRunDetails = (options: Options<GetRunDetailsData>) => { return (options?.client ?? client).post<GetRunDetailsResponse, GetRunDetailsError>({
    ...options,
    url: '/v1/api/task/get_run_details'
}); };

export const getTasksByOrchSha = (options: Options<GetTasksByOrchShaData>) => { return (options?.client ?? client).post<GetTasksByOrchShaResponse2, GetTasksByOrchShaError>({
    ...options,
    url: '/v1/api/task/get_tasks_by_orch_sha'
}); };

export const kill = (options: Options<KillData>) => { return (options?.client ?? client).post<KillResponse, KillError>({
    ...options,
    url: '/v1/api/task/kill'
}); };

export const taskList = (options: Options<TaskListData>) => { return (options?.client ?? client).post<TaskListResponse, TaskListError>({
    ...options,
    url: '/v1/api/task/list'
}); };

export const listTaskRuns = (options: Options<ListTaskRunsData>) => { return (options?.client ?? client).post<ListTaskRunsResponse2, ListTaskRunsError>({
    ...options,
    url: '/v1/api/task/list_task_runs'
}); };

export const pause = (options: Options<PauseData>) => { return (options?.client ?? client).post<PauseResponse, PauseError>({
    ...options,
    url: '/v1/api/task/pause'
}); };

export const networkService = (options: Options<NetworkServiceData>) => { return (options?.client ?? client).post<NetworkServiceResponse, NetworkServiceError>({
    ...options,
    url: '/v1/api/task/run_continuously'
}); };

export const oneshot = (options: Options<OneshotData>) => { return (options?.client ?? client).post<OneshotResponse, OneshotError>({
    ...options,
    url: '/v1/api/task/run_once'
}); };

export const cronJob = (options: Options<CronJobData>) => { return (options?.client ?? client).post<CronJobResponse, CronJobError>({
    ...options,
    url: '/v1/api/task/run_scheduled'
}); };

export const pipelinesDeploy = (options: Options<PipelinesDeployData>) => { return (options?.client ?? client).post<PipelinesDeployResponse, PipelinesDeployError>({
    ...options,
    url: '/v1/api/pipelines/deploy'
}); };

export const pipelinesUndeploy = (options: Options<PipelinesUndeployData>) => { return (options?.client ?? client).post<PipelinesUndeployResponse, PipelinesUndeployError>({
    ...options,
    url: '/v1/api/pipelines/undeploy'
}); };

export const get = (options: Options<GetData>) => { return (options?.client ?? client).post<GetResponse, GetError>({
    ...options,
    url: '/v2/api/assays/get'
}); };

export const getById = (options: Options<GetByIdData>) => { return (options?.client ?? client).post<GetByIdResponse, GetByIdError>({
    ...options,
    url: '/v2/api/assays/get/:id'
}); };

export const getNextRun = (options: Options<GetNextRunData>) => { return (options?.client ?? client).post<GetNextRunResponse2, GetNextRunError>({
    ...options,
    url: '/v2/api/assays/get_next_run'
}); };

export const getResults = (options: Options<GetResultsData>) => { return (options?.client ?? client).post<GetResultsResponse, GetResultsError>({
    ...options,
    url: '/v2/api/assays/get_results'
}); };

/**
 * Previewing takes the same arguments as [`crate::assays::http::schedule`] but introduces a new arg: PreviewWindow
 */
export const preview = (options: Options<PreviewData>) => { return (options?.client ?? client).post<PreviewResponse2, PreviewError>({
    ...options,
    url: '/v2/api/assays/preview'
}); };

/**
 * Previewing a Baseline is requesting a histogram that shows how
 * the baseline's data would be binned for comparison to windows.
 * The minimal response is therefore a dataframe:
 * _|    bins    | count
 * 0| (-Inf, 0.1]| 5
 * 1| (0.1, 0.24]| 10
 * 2| (0.24, 0.4]| 11
 * 3| (0.4, 0.45]| 6
 * 4| (0.45, Inf)| 2
 *
 * Bins may also have descriptive labels, such as quantiles, or user-provided labels.
 * The first and last bins, to infinity, are designated as outliers.
 *
 * curl -X POST localhost:3040/v2/api/assays/preview_baseline_binning -H 'Authorization: Bearer test' -H 'Content-Type: application/json' -d '{"baseline": {"Static": ["2023-07-16T15:40:28+00:00", "2023-07-26T15:40:28+00:00"]}}'
 * curl -X POST localhost:3040/v2/api/assays/preview_baseline_binning -H 'Authorization: Bearer test' -H 'Content-Type: application/json' -d '{"baseline": {"Summary": {"bins": {"mode": {"Equal": 10}, "edges": [],"labels": []},"aggregated_values": [],"aggregation": "Edges","statistics": {"count": 21,"min": 1,"max": 21,"mean": 10,"median": 10,"std": 2}}}}'
 * curl -X POST http://localhost:3040/v2/api/assays/preview_baseline_binning -H 'Authorization: Bearer test' -H 'Content-Type: application/json' -d '{"baseline": {"Static": ["2022-01-06T00:00:00+00:00", "2022-01-07T00:00:00+00:00"]}}' | jq .
 * curl -X POST http://localhost:3040/v2/api/assays/preview_baseline_binning -H 'Authorization: Bearer test' -H 'Content-Type: application/json' -d '{"baseline": {"Static": ["2022-01-06T00:00:00+00:00", "2022-01-07T00:00:00+00:00"]}, "targeting": {"data_origin": {"pipeline_name": "modelinsightse2e05246", "workspace_id": 1}, "iopath": [{"field": "out.dense_2", "index": 9}]}, "summarizer": {"UnivariateContinuous": {"bin_mode": {"Equal": 8},"aggregation": "Density","metric": "PSI","bin_weights": null}}}'
 */
export const previewBaselineBinning = (options: Options<PreviewBaselineBinningData>) => { return (options?.client ?? client).post<PreviewBaselineBinningResponse, PreviewBaselineBinningError>({
    ...options,
    url: '/v2/api/assays/preview_baseline_binning'
}); };

export const schedule = (options: Options<ScheduleData>) => { return (options?.client ?? client).post<ScheduleResponse2, ScheduleError>({
    ...options,
    url: '/v2/api/assays/schedule'
}); };

/**
 * Scoring is the process of:
 * 1. Taking 2 ranges of data
 * 2. Summarizing them
 * 3. Using a [`Metric`] to summarize the difference between their Summaries.
 *
 * curl -X POST http://localhost:3040/v2/api/assays/score -H 'Authorization: Bearer test' -H 'Content-Type: application/json' -d '{"window": {"Stored": ["2022-01-06T00:00:00+00:00", "2022-01-07T00:00:00+00:00"]}, "baseline": {"Static": ["2022-01-01T00:00:00+00:00", "2022-01-02T00:00:00+00:00"]}, "summarizer": {"UnivariateContinuous": {"bin_mode":{"Equal":8},"aggregation":"Density","metric":"PSI","bin_weights":null}}}'
 *
 */
export const score = (options: Options<ScoreData2>) => { return (options?.client ?? client).post<ScoreResponse2, ScoreError>({
    ...options,
    url: '/v2/api/assays/score'
}); };

export const setActive = (options: Options<SetActiveData>) => { return (options?.client ?? client).post<SetActiveResponse2, SetActiveError>({
    ...options,
    url: '/v2/api/assays/set_active'
}); };